import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let cache = null;

/**
 * Returns the policy file's last-modified date (formatted) for display.
 * Auto-bumps any time the policy file is edited because the backend reads
 * the React file's mtime directly.
 */
export function useLastUpdated(policyKey) {
  const [date, setDate] = useState(null);

  useEffect(() => {
    let cancel = false;
    const apply = (data) => {
      if (cancel || !data) return;
      const iso = data[policyKey];
      if (!iso) return;
      const d = new Date(iso);
      setDate(d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }));
    };
    if (cache) {
      apply(cache);
    } else {
      axios
        .get(`${API}/policies/last-updated`)
        .then((r) => { cache = r.data; apply(r.data); })
        .catch(() => {});
    }
    return () => { cancel = true; };
  }, [policyKey]);

  return date;
}
